<template>

    <m-edit1/>

    <m-verify-email-1 v-bind='{...{"image":null},...{}}' :style='""' class="" ></m-verify-email-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mVerifyEmail1 from '@moeinmdn/miw-alpha-components/src/package/Authentication/VerifyEmail/VerifyEmail1';

export default {
    name: 'HomeView',
    components: {mEdit1, mVerifyEmail1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
